export default "__VITE_ASSET__DusSMWhV__"